import React from 'react';
import {PlayersList as BasePlayersList} from 'desktop/sports/nfl/players-list/classic';
import {connect} from 'react-redux';

class PlayersList extends BasePlayersList {
    getSearchConditions() {
        return {
            ...this.getSearchRuleByMode({
                overallMode: {
                    checkPointsExclusion: true,
                    checkSalaryExclusion: true,
                },
            }),
            ...this.getSearchRuleByMultiPosition(),
            ...this.getSearchRuleByPlayerName(),
            ...this.getSearchRuleByTeamName(),
        };
    }
}

function mapStatesToProps(state) {
    const {sportConfig, reset, playersLock, userPointsType, modesConfig} = state;
    const {players, filters: playersFilter, games} = state.playersData;

    return {
        players,
        games,
        playersFilter,
        playersLock,
        sportConfig,
        reset,
        userPointsType,
        modesConfig,
    };
}

let Table = connect(mapStatesToProps)(PlayersList);

export {Table};
